/**
 * The delivery charge line an order carries (server/services/deliveryFee.ts). It is
 * worked out when the order is read, never stored on it: the order's responses carry it
 * as `deliveryFee`, null when the order gets none.
 */
export interface DeliveryFeeLine {
  productId: number;
  name: string;
  quantity: 1;
  /** null = the product has no price yet. */
  price: number | null;
}

/**
 * Whether an order is a delivery: everything but an explicit pickup. A NULL type (a
 * Clyde order, a very old one) reads as delivery, as everywhere else in the app.
 */
export function orderGetsDeliveryFee(order: { fulfillmentType?: string | null }): boolean {
  return order.fulfillmentType !== "pickup";
}

export function formatDeliveryFeePrice(price: number | null): string {
  return price == null ? "" : `$${price.toFixed(2)}`;
}
